module.exports = __webpack_public_path__ + "assets/img/05-s.4173613.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/05-s.jpg
// module id = szEJ
// module chunks = 0